import React, {Component} from 'react';
import {Form, Control, Errors} from 'react-redux-form'
import _ from "lodash";
import {isRequired} from "../field_validations";

export default class AxisEditForm extends Component{
	render(){
		const { status } = this.props;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="axis.edit" onSubmit={(goals) => this._submitForm(goals)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre del Objetivo <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".name" id="name" rows={2} className="textarea" placeholder="Nombre de la Meta" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="code" className="label">Código <span className="small has-text-danger">*</span></label>
								<Control.text model=".code" id="code" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".code" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength2: 'Codigo no valido'}} />
							</div>

							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" validateOn="change">
										<option value="">--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/proigualdad/ejes')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="axis.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values) {
		this.props.axisEditSave(values);
	}

	_validateSave(){
		const {axis} = this.props;
		let ac = _.find(axis.permissions, (o) => {return o==='Create'});
		let au = _.find(axis.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(axis.edit) && axis.edit.id){
			if(au){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(axis.edit) && _.isEmpty(axis.edit.id)){
			if(ac){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/axis/form.jsx